import { motion } from "framer-motion";

const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_ef349217-03f0-42a5-8ca7-f240d73234a2/artifacts/vudnoq21_file_000000005ef081f5bdf0c8fd58404195.png";

/** Masked line-by-line reveal for hero headline */
export function MaskedLines({ lines, delay = 0.2, className = "" }) {
    return (
        <div className={className}>
            {lines.map((line, i) => (
                <div key={i} className="reveal-mask" style={{ display: "block", overflow: "hidden" }}>
                    <motion.span
                        initial={{ y: "100%", opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{
                            duration: 1.2,
                            delay: delay + i * 0.14,
                            ease: [0.76, 0, 0.24, 1],
                        }}
                        style={{ display: "inline-block" }}
                    >
                        {line}
                    </motion.span>
                </div>
            ))}
        </div>
    );
}

/** Scroll-triggered fade + Y reveal */
export function Reveal({ children, delay = 0, y = 24, className = "", once = true }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay, ease: [0.25, 0.1, 0.25, 1] }}
            viewport={{ once, margin: "-80px" }}
        >
            {children}
        </motion.div>
    );
}

export const PassportLogo = ({ size = 32, className = "" }) => (
    <img src={LOGO} alt="Passport" width={size} height={size} className={`rounded-md ${className}`} />
);
